module.exports = __webpack_public_path__ + "static/media/bg-icon-mission2.a35c5385.png";